const SupEmptyState = ({ icon: Icon, title, subtitle }) => {
  return (
    <div className="sup-empty">
      {Icon && <Icon size={40} className="sup-empty__icon" />}
      <p className="sup-empty__title">{title}</p>
      {subtitle && <p className="sup-empty__subtitle">{subtitle}</p>}
    </div>
  );
};

export default SupEmptyState;